import { Component, OnInit, Input, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Router } from '@angular/router';
import { IvAssessmentFormComponent } from '../iv-assessment-form/iv-assessment-form.component';
import { DocumentService } from '../../services/document.service';
import { PortfolioService } from '../../services/portfolio/portfolio.service';
import { LearnerService } from '../../services/learner.service';

@Component({
  selector: 'app-iv-unit-list',
  templateUrl: './iv-unit-list.component.html',
  styleUrls: ['./iv-unit-list.component.scss']
})
export class IvUnitListComponent implements OnInit {

  @Input('assignment') listOfAssignment
  @Input('currentJob') job
  @Input('learners') learnersList
  @Input('type') courseType
  @Input('units') unitList
  @Input('courseId') course
  @Input('jobData') jobDetails
  @Input('jobEdit') editJob
  @Output() details: EventEmitter<any> = new EventEmitter<any>();
  assignmentList = []
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  jobId
  displayedColumns = ['unit', 'assignment', 'action'];
  allLearners = []
  selectedCourse
  allUnitList = []
  singleJob
  courseId
  sampleList = []
  isEditJob
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @ViewChild(IvAssessmentFormComponent, { static: false }) ivComp;

  constructor(
    private router: Router,
    private documentSerivce: DocumentService,
    public _portfolioService: PortfolioService,
    private _learnerService: LearnerService,
  ) {
    this.dataSource = new MatTableDataSource(this.assignmentList);
  }

  ngOnInit() {
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("get all list of units in main page", changes);
    if (changes.listOfAssignment && changes.listOfAssignment.currentValue) {

      this.assignmentList = changes.listOfAssignment.currentValue

      this.updateData(this.assignmentList)
    }
    if (changes.job && changes.job.currentValue) {
      this.jobId = changes.job.currentValue
      // this.getLearners()
    }

    if (changes.learnersList && changes.learnersList.currentValue) {
      this.allLearners = changes.learnersList.currentValue
    }

    if (changes.course && changes.course.currentValue) {
      this.courseId = changes.course.currentValue
    }
    if (changes.courseType && changes.courseType.currentValue) {
      this.selectedCourse = changes.courseType.currentValue
      if (this.selectedCourse == 'Level2') {
        this.getLevel2Units()
      }
    }

    if (changes.unitList && changes.unitList.currentValue) {
      this.allUnitList = changes.unitList.currentValue
    }

    if (changes.jobDetails && changes.jobDetails.currentValue) {
      this.singleJob = changes.jobDetails.currentValue
    }
    if (changes.editJob && changes.editJob.currentValue) {
      this.isEditJob = changes.editJob.currentValue
    }
  }


  // Utility


  updateData(assignment) {
    console.log("UPDATING DATA = ", assignment)
    console.log("Emitting event getLearnersFromComponent with learners = ", assignment);
    // this.getLearnersFromComponent.emit({ learners })
    this.dataSource = new MatTableDataSource(assignment);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("DATASOURCE", this.dataSource)
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  redirect(data) {
    // if (this.ivComp) {
    console.log("when click on table", data);
    // this.sendData(obj)

    // this.details.emit(obj)
    // this.documentSerivce.getIqaData(obj)
    // this.ivComp.getFormData(this.allLearners)
    this.router.navigate(['/document-iv/document-iv/'], { queryParams: { jobId: this.jobId, assignment: data.assignmentTitle, assignmentId: data.assignmentId, unitTitle: data.assignmentUnit.title, courseType: this.selectedCourse } })

  }

  sendData(obj) {
    this.documentSerivce.getIqaData(obj)
  }


  updateSamples(event) {
    console.log("event of testing", event);
    this.sampleList = event
  }

  // API CALL

  getLevel2Units() {
    console.log("single job details=======", this.courseId);

    this._portfolioService.getClassromGroupedByCourseId(this.courseId).subscribe(res => {
      console.log("response of all units of level2 job", res);
      let unitArray = []
      if (res && res.length) {
        let units = res
        units.forEach((item) => {

          item.session.forEach((singleItem) => {
            let obj = {
              assignmentTitle: singleItem.sessionTitle,
              assignmentNo: singleItem.sessionUnit,
              assignmentId: singleItem.sessionId,
              assignmentUnit: {
                unitNo: item._id,
                title: item._id
              }
            }
            unitArray.push(obj)
          })
        })

        console.log("this is the final array to display for level2 job", unitArray);
        this.updateData(unitArray)

      }

    }, error => {
      console.log("error while get all units of jobs", error);

    })
  }

  getLearners() {
    this._learnerService.getLearnersByJobId(this.jobId).subscribe(responseLearner => {
      this.allLearners = responseLearner;
      console.log("***this.allLearners in job", this.allLearners);
    })
  }



}
